import { Mail, MessageCircle, Linkedin } from "lucide-react";

const LOGO_URL =
  "/ponzena-logo.png";

export default function Footer() {
  return (
    <footer className="relative border-t border-cyan-400/15 py-14 mt-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="Ponzena - Transformação Digital para Empresas"
              className="h-14 md:h-16 w-auto object-contain"
            />
            <p className="text-[#8892B0] mt-6 max-w-md leading-relaxed">
              Consultoria sênior em transformação digital, ERPs e IA aplicada. Modernizamos o backoffice e damos autonomia ao seu time.
            </p>
          </div>

          <div>
            <p className="label-eyebrow mb-4">Navegar</p>
            <ul className="space-y-2 text-[#B8C0D0] text-sm">
              <li><a href="#sobre" className="hover:text-cyan-400">Sobre</a></li>
              <li><a href="#servicos" className="hover:text-cyan-400">Serviços</a></li>
              <li><a href="#erps" className="hover:text-cyan-400">ERPs</a></li>
              <li><a href="#academy" className="hover:text-cyan-400">Academy</a></li>
              <li><a href="#faq" className="hover:text-cyan-400">FAQ</a></li>
            </ul>
          </div>

          <div>
            <p className="label-eyebrow mb-4">Contato</p>
            <ul className="space-y-3 text-[#B8C0D0] text-sm">
              <li>
                <a
                  href="https://wa.me/5511980331231"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:text-cyan-400"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle size={14} /> (11) 98033-1231
                </a>
              </li>
              <li>
                <a
                  href="mailto:david.ponzenato@ponzena.com.br"
                  className="inline-flex items-center gap-2 hover:text-cyan-400 break-all"
                  data-testid="footer-email"
                >
                  <Mail size={14} /> david.ponzenato@ponzena.com.br
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:text-cyan-400"
                >
                  <Linkedin size={14} /> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 pb-20 md:pb-0 border-t border-cyan-400/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#8892B0] font-mono-tech tracking-wider">
            © {new Date().getFullYear()} PONZENA · TRANSFORMAÇÃO DIGITAL PARA EMPRESAS · TODOS OS DIREITOS RESERVADOS
          </p>
          <p className="text-xs text-[#8892B0] font-mono-tech tracking-wider">
            &lt;/&gt; feito com café, IA e código
          </p>
        </div>
      </div>
    </footer>
  );
}
